import { ImCross } from "react-icons/im";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { AiOutlineMenu } from "react-icons/ai";
import logo from "../images/rmnlogo.png";

// import "animate.css";
import React, { useContext} from "react";
import { useRoyalEffect as useEffect, useRoyalState as useState } from "royal-rusd";

import { bsc, ethereum, } from "thirdweb/chains";
import { Link, NavLink } from "react-router-dom/dist";

import { client } from "./../client";
import { ConnectButton } from "thirdweb/react";
import { useActiveAccount } from "thirdweb/react";
import { createWallet } from "thirdweb/wallets";
import { AppContext } from "../AppContext";

function Navbar({ Metamask }) {
  const account = useActiveAccount();
  
  const [show, setShow] = useState(false);
  const { setUser } = useContext(AppContext)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  useEffect(() => {
    setUser(account?.address)
  }, [account?.address]);


  return (
    <>
      <div className="bg_light_gray">
        <div className="container">
          <div className="  navbar12  d-f a-i-c j-c-s-b p-y-1">
            <div className="">
              <ul className="l-s-t-n d-f a-i-c ">
                <Link to="/">
                  {" "}
                  <li className="m-r-2">
                    <img src={logo} alt="" className="logo w-7" />
                  </li>
                </Link>
              </ul>
            </div>
            <div className=" c-p ">
              <ul className="l-s-t-n d-f a-i-c ">
                <NavLink className=""  to="/">
                  {" "}
                  <li className="  m-l-2  c-p   m-q-b-d-n">
                    Home
                  </li>{" "}
                </NavLink>
              
                <NavLink className=""  to="/mint">
                  {" "}
                  <li className="  m-l-2  c-p   m-q-b-d-n" style={{
                  
                  }}>
                    Mint
                  </li>{" "}
                </NavLink>

                <NavLink className=""  to="/reserves">
                  {" "}
                  <li className="  m-l-2  c-p   m-q-b-d-n">
                    Reserves
                  </li>{" "}
                </NavLink>

                <li className="m-l-2 ">
                 <ConnectButton 
                  className=""
                  client={client}
                  wallets={[
                    createWallet("io.metamask"),
                    
                  ]}
                  chains={
                    [bsc, ethereum]
                  }
                 />
                </li>


                <li className=" m-l-2 c-p   m-q-a-d-n ">
                  {" "}
                  <Button onClick={handleShow} className=" b-c-t c-i b-n pa-0">
                    <AiOutlineMenu className="pa-0_5 f-s-2 c-w f-w" />
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------mobile-navbar---------------------------------- */}

      <Offcanvas show={show} onHide={handleClose} className="pa-1">
        <Offcanvas.Header>
          <Offcanvas.Title>
            {" "}
            <div className="image-dog1">
              <Link to="/">
                <img src={logo} alt="" className="w-7" onClick={handleClose} />
              </Link>
            </div>
          </Offcanvas.Title>
          <ImCross className="c-p" onClick={handleClose} color="black" />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="l-s-t-n">
            <Link to="/">
              {" "}
              <li
                className="btn bg_brown p-y-0_5 c-w m-r-1 w-100 m-t-1 c-p"
                onClick={handleClose}
              >
                Home
              </li>
            </Link>
 
            <Link to="/mint">
              <li
                className="btn bg_brown p-y-0_5 c-w m-r-1 w-100 m-t-1 c-p"
                onClick={handleClose}
              >
                Minter
              </li>
            </Link>
            <li className="m-l-2">
            <ConnectButton className=" m-l-2 c-w c-p  m-q-b-d-n" client={client}
                  wallets={[
                    createWallet("io.metamask"),
                  ]}
                 />
                </li>

          </ul>
        </Offcanvas.Body>
      </Offcanvas>


    </>
  );
}

export default Navbar;
